import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import { _sessionKeys, _sessionType, _toastVariants } from "../../utils/Constant";
import { apiRequest } from "../../utils/config/apiRequest";
import { apiUrl } from "../../utils/endPoints/apiUrl";
import { _vendorAdminRoutes } from "../../utils/appRouter";
import { accessSessionData } from "../../utils/helper/authHelper";
import { emailRegex, passwordRegex } from "../../utils/regex/formRegexConstant";
import { showMessage } from "../../utils/toast/globalToast";


const Login = () => {
    // const { login } = useAuth();
    const [hideShowPass, setHideShowPass] = useState(true);
    const navigate = useNavigate();

    const initialValues = {
        email: "",
        password: "",
        remember: false,
    };
    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .trim()
            .matches(
                emailRegex,
                "Please enter a valid email--(format example@example.com)"
            )
            .required("Email is required"),
        password: Yup.string()
            .trim()
            .matches(
                passwordRegex,
                "Use a password with 8+ characters, 1 letter, 1 number, and 1 special character"
            )
            .required("Password is required"),
    });
   const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
        try {
            const payload = {
                email: values.email,
                password: values.password,
            };

            const { data, status, message } = await apiRequest({
                endUrl: apiUrl.login,
                method: 'POST',
                body: payload,
            });

            if (status && data.user?.isVendor) {

                // accessSessionData(_sessionType.setData, _sessionKeys.access_token, data.jwtToken);
                // accessSessionData(_sessionType.setData, _sessionKeys.loggedInUser, JSON.stringify(data.user));
                localStorage.setItem("access_token", data.jwtToken);
                localStorage.setItem("loggedInUser", JSON.stringify(data.user));

                
                if (data.user?.status === "PENDING") {
                    navigate("/signup", { state: { fromLogin: true } });
                    showMessage({ variant: _toastVariants.Error, message: "Your vendor registration is under review." });
                    return;
                }

                showMessage({ variant: _toastVariants.Success, message: "Login successful" });
                navigate(_vendorAdminRoutes.dashboard);
            } else {
                showMessage({ variant: _toastVariants.Error, message: message || "Login failed" });
            }
        } catch (error) {
            showMessage({ variant: _toastVariants.Error, message: error.message });
        } finally {
            setSubmitting(false);
        }
    },
    });


    const { values, touched, errors, setFieldValue, handleSubmit } = formik;
    return (
        <div>
            <div className="signin-wrapper">
                <div className="container py-5 d-flex align-items-center justify-content-center">
                    <div className="row loginbox">
                        <div className="col-md-7 left-section-bg">
                            <div className="rightimg position-relative">
                                <img src="images/loginbg.png" alt="" className="w-100 h-100" />
                            </div>
                        </div>

                        <div className="col-md-5">
                            <div className="right-section px-5">
                                <form onSubmit={handleSubmit} >
                                    <div className="row">
                                        <div className="col-md-12 text-center">
                                            <img src="images/logo.png" height="62px" alt="" />
                                        </div>

                                        <div className="col-md-12">
                                            <h5 className="login-heading mt-4">Let's get started!</h5>
                                            <p className="login-subheading">Enter the following details!</p>
                                        </div>

                                        <div className="col-md-12">
                                            <label htmlFor="email" className="input-label mb-1">Email address</label>
                                            <div className="mb-3 position-relative">
                                                <input
                                                    type="text"
                                                    className="form-control login-input"
                                                    placeholder="Your email address.."
                                                    value={values?.email}
                                                    onChange={(e) => setFieldValue('email', e.target.value?.trim()?.replace(/\s/g, ''))}
                                                />
                                                {touched?.email && errors?.email ? (
                                                    <span style={{ fontSize: '14px', color: 'red' }}>{errors?.email}</span>
                                                ) : ''}
                                                <img src="images/mail.png" className="iconimg" height="15px" alt="" />
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <label htmlFor="password" className="input-label mb-1">Password</label>
                                            <div className="mb-3 position-relative">
                                                <input
                                                    type={hideShowPass ? 'password' : 'text'}
                                                    value={values?.password?.trim()}
                                                    className="form-control login-input"
                                                    onChange={(e) => setFieldValue('password', e.target.value?.trim()?.replace(/\s/g, ''))}
                                                    placeholder="*******"
                                                />
                                                {hideShowPass ? (
                                                    <img style={{ cursor: 'pointer' }} onClick={() => setHideShowPass(false)} src="/images/close-eyesinput.svg" className="input-icons" alt="/" />
                                                ) : (
                                                    <img style={{ cursor: 'pointer' }} onClick={() => setHideShowPass(true)} src="/images/open-eyesinput.svg" className="input-icons" alt="/" />
                                                )}
                                                {touched?.password && errors?.password ? (
                                                    <span style={{ fontSize: '14px', color: 'red' }}>{errors?.password}</span>
                                                ) : ''}
                                                <img src="images/closeeye.png" className="iconimg" height="15px" alt="" />

                                            </div>
                                        </div>

                                        {/* <div className="col-md-12 mt-3">
                                            <div className="d-flex justify-content-between align-items-center mb-5">
                                                <div className="form-check d-flex align-items-center">
                                                    <input className="form-check-input custom-checkbox" type="checkbox"
                                                        id="remember" defaultChecked />
                                                    <label className="form-check-label custom-label ml-2"
                                                        htmlFor="remember">Remember</label>
                                                </div>
                                                <a href="#" className="small-txt">Forgot password?</a>
                                            </div>
                                        </div> */}

                                        <div className="col-md-12 mb-5">
                                            <button type="submit" className="btn btn-dark login-btn">Sign in</button>
                                        </div>

                                        <div className="col-md-12">
                                            <p className="text-center foot-text">New user? <Link to="/signup"
                                                style={{ textDecoration: 'underline' }}> Signup now!</Link></p>
                                        </div>

                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
